import { connect } from 'react-redux'

import { setConnectionStatus } from '../actions/connectionStatus'

const mapStateToProps = state => ({
  connectionStatus: state.connectionStatus.connectionStatus,
  stage: process.env.REACT_APP_STAGE,
  fetchPolicy:
    state.connectionStatus.connectionStatus === 'online'
      ? 'cache-and-network'
      : 'cache-only'
})

const mapDispatchToProps = dispatch => ({
  setConnectionStatus: lang => dispatch(setConnectionStatus(lang))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)



// WEBPACK FOOTER //
// ./src/hocs/withConnectionStatus.js